import { render, staticRenderFns } from "./AddSubscriptionPage.vue?vue&type=template&id=5ff8ecff"
import script from "./AddSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./AddSubscriptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports